import { FIELD_TYPE, ACTION_TYPE, BEHAVIOR_TYPE } from './constants'
import PubSub from 'pubsub-js'
import { CombinedGraphQLErrors } from '@apollo/client'

export function deepCopy(object) {
  return JSON.parse(JSON.stringify(object))
}

export function makeInteger(value) {
  let newInteger = value
  if (typeof value === 'string') {
    newInteger = parseInt(value)
  }
  return newInteger
}

function getFilteredParts() {
  const parts = window.location.pathname.split('/')
  const filteredParts = parts.filter((item) => {
    return item !== ''
  })
  return filteredParts
}

export function getTenant() {
  let tenant = null
  const filteredParts = getFilteredParts()
  if (filteredParts.length > 0) {
    tenant = filteredParts[0]
  }
  return tenant
}

export function getLoginInfo() {
  let loginInfo = null
  const tenant = getTenant()
  //console.log('utils.getLoginInfo tenant: ', tenant)
  const dataString = getLocalStorage(tenant)
  if (dataString) {
    loginInfo = JSON.parse(dataString)
    //console.log('utils.getLoginInfo tenant: ', tenant, loginInfo)
  }
  return loginInfo
}

export function getLoginItem(name) {
  let item = null
  const loginInfo = getLoginInfo()
  if (loginInfo) {
    item = loginInfo[name]
  }
  return item
}

export function setLoginItem(name, value) {
  const loginInfo = getLoginInfo()
  if (loginInfo) {
    loginInfo[name] = value
    setLocalStorage(getTenant(), JSON.stringify(loginInfo))
  }
}

export function getLocalStorage(name) {
  return localStorage.getItem(name)
}

export function setLocalStorage(name, value) {
  localStorage.setItem(name, value)
}

export function removeItem(name) {
  localStorage.removeItem(name)
}

export function getSessionStorage(name) {
  return sessionStorage.getItem(name)
}

export function setSessionStorage(name, value) {
  sessionStorage.setItem(name, value)
}

export function removeSessionItem(name) {
  sessionStorage.removeItem(name)
}

export function isLoggedIn() {
  let isLoggedIn = false
  if (getLocalStorage(getTenant())) {
    isLoggedIn = true
  }
  return isLoggedIn
}

export function getHookInfo(hookString) {
  const parts = hookString.split('.')
  const hookInfo = {
    moduleName: parts[0],
    functionName: parts[1]
  }
  return hookInfo
}

export function extractCustomLoginData(loginData) {
  //console.log('utils.extractCustomLoginData: ', loginData)
  // BEGIN BACKWARD COMPATIBILITY:  move "custom" object fields up to root object level
  const newLoginData = deepCopy(loginData)
  newLoginData.attributes = loginData.custom.attributes
  newLoginData.configuration = loginData.custom.configuration
  newLoginData.currentWorkspaceId = loginData.custom.currentWorkspaceId
  newLoginData.entryPoint = loginData.custom.entryPoint 
  newLoginData.fieldTypes = loginData.custom.fieldTypes
  newLoginData.tenant = loginData.custom.tenant
  delete newLoginData.custom
  //console.log('utils.extractCustomLoginData: ', newLoginData)
  return newLoginData
}

export function signIn(loginData) {
  console.log('utils.signIn: ', loginData)
  const newLoginData = extractCustomLoginData(loginData)
  console.log('utils.signIn: ', newLoginData)
  setLocalStorage(loginData.custom.tenant, JSON.stringify(newLoginData))
}

export function signOut() {
  removeItem(getTenant())
}

function createDefaultTab(objectType, refType) {
  const tab = {
    id: -1,
    name: objectType.name,
    tabFields: [],
  }
  objectType.fields.forEach((field, index) => {
    let xPos = 1
    let yPos = index
    if (refType) {
      xPos = index
      yPos = 1
    }
    const tabField = {
      id: index,
      field: field,
      xPosition: xPos,
      yPosition: yPos,
      showLabel: 'Y'
    }
    tab.tabFields.push(tabField)
  })
  const tabs = [tab]
  return tabs
}

function getSubmitFormTabs(objectType) {
  console.log('utils.getSubmitFormTabs', objectType)
  for (let form of objectType.forms) {
    if (form.submitForm === 'Y') {
      return form.tabs ? form.tabs : []
    }
  }
  return createDefaultTab(objectType)
}

function getRecordFormTabs(objectType) {
  console.log('utils.getRecordFormTabs', objectType)
  for (let form of objectType.forms) {
    if (form.recordForm === 'Y') {
      return form.tabs ? form.tabs : []
    }
  }
  return createDefaultTab(objectType)
}

function getReferenceFormTabs(objectType) {
  console.log('utils.getRecordFormTabs', objectType)
  for (let form of objectType.forms) {
    if (form.submitForm === 'Y') {
      return form.tabs ? form.tabs : []
    }
  }
  return createDefaultTab(objectType, 'refType')
}

export function getTabs(objectType, action, parent, viewDetail = false) {
  console.log('utils.getTabs: ', objectType, action, parent, viewDetail)
  let tabs = []
  if (action) {
    const actionType = makeInteger(action.type.id)
    if (actionType === ACTION_TYPE.submit) {
      tabs = getSubmitFormTabs(objectType)
    } else if (actionType === ACTION_TYPE.modify || actionType === ACTION_TYPE.changeState) {
      tabs = getRecordFormTabs(objectType)
    }
  } else {
    // No distinction between viewing in ref list and viewing details
    if (parent && !viewDetail) {
      tabs = getReferenceFormTabs(objectType)
    } else {
      tabs = getRecordFormTabs(objectType)
    }
  }
  console.log('utils.getTabs: ', tabs)

  return tabs
}

export function isDisabled(action, behaviorType) {
  if (behaviorType && makeInteger(behaviorType.id) === BEHAVIOR_TYPE.readOnly) {
    return true
  } else {
    if (!action) {
      return true
    } else {
      return false
    }
  }
}

export function hasActionType(actions, actionTypeId) {
  if (actions) {
    for (let i = 0; i < actions.length; i++) {
      if (makeInteger(actions[i].type.id) === makeInteger(actionTypeId)) {
        return true
      }
    }
  }
  return false
}

export function getActionOfType(actions, actionTypeId) {
  for (let i = 0; i < actions.length; i++) {
    if (makeInteger(actions[i].type.id) === makeInteger(actionTypeId)) {
      return actions[i]
    }
  }
  return null
}

export function reverseDate(date) {
  date = date.split('-')
  date = `${date[1]}-${date[2]}-${date[0]}`
  return date
}

export function getAlignment(fieldTypeId) {
  let className = null
  switch (fieldTypeId) {
    case FIELD_TYPE.yesNo:
    case FIELD_TYPE.objectId:
      className = 'centered'
      break
    case FIELD_TYPE.date:
      className = 'centered nowrap'
      break
    case FIELD_TYPE.currency:
    case FIELD_TYPE.integer:
    case FIELD_TYPE.number:
      className = 'right'
      break
    default:
      className = ''
  }
  return className
}

export function getField(fieldId, fromObject) {
  for (let field of fromObject.type.fields) {
    if (makeInteger(field.id) === makeInteger(fieldId)) {
      return field
    }
  }
  return null
}

export function createInitialFormInput(fromObject, action) {
  console.log(`****************************** createInitialFormInput (${fromObject.type.name}) ***************************`, fromObject, action)
  const formData = {}
  for (let fieldId in fromObject.data) {
    const fieldData = {}
    fieldData.field = getField(fieldId, fromObject)

    let fieldValue = fromObject.data[fieldId]
    // change null value into empty string ''
    if (fieldValue === null) {
      fieldValue = ''
    }

    if (makeInteger(fieldData.field.type.id) === FIELD_TYPE.referenceList) {
      fieldValue = {}
    }

    fieldData.savedValue = fieldValue
    fieldData.currentValue = deepCopy(fieldValue)
    fieldData.changed = false

    // set default value and changed
    if (action && makeInteger(action.type.id) === ACTION_TYPE.submit) {
      if (fromObject.defaults[fieldId]) {
        fieldData.currentValue = fromObject.defaults[fieldId]
        // set changed = true only for fields that are NOT readOnly
        if (FIELD_TYPE.readOnly.indexOf(makeInteger(fieldData.field.type.id)) === -1) {
          fieldData.changed = true
        }
      }
    }
    formData[fieldId] = fieldData
    if (action) {
      formData.action = action
    }
  }
  return formData
}

export function createFieldLookup(fields) {
  const fieldsById = {}
  let field
  for (field of fields) {
    fieldsById[field.id] = {
      name: field.name,
      columnName: field.columnName,
      fieldTypeId: field.type.id,
      multiTableName: field.multiTableName,
      choiceTableName: field.choiceTableName,
      dataStoreHook: field.dataStoreHook,
      encrypt: field.encrypt,
    }
  }
  return fieldsById
}

export function publishEvent(eventTopic, eventData, caller) {
  console.log(`EVENT PUBLISHED (${caller}): ${eventTopic}`, eventData)
  PubSub.publish(eventTopic, eventData)
}

export function publishEventSync(eventTopic, eventData, caller) {
  console.log(`EVENT PUBLISHED (${caller}): ${eventTopic}`, eventData)
  PubSub.publishSync(eventTopic, eventData)
}

export function hasSidebar() {
  const entryPoint = getLoginItem('entryPoint')
  if (entryPoint && entryPoint.toUpperCase() === 'APP_VIEW.FRAMES') {
    return false
  }
  return true
}

export function getBaseName() {
  const tenant = getTenant()
  return `/${tenant}/`
}

export async function fetchBlob(url, successCallback, errorCallback) {

  function handleErrors(response) {
    if (!response.ok) {
      throw Error(response.statusText)
    }
    return response
  }

  fetch(url, {
    method: 'get',
    mode: 'cors',
    headers: {
      'Authorization': 'Bearer ' + getLoginItem('jwt')
    }
  })
    .then(handleErrors)
    .then(response => response.blob())
    .then(blob => {
      const blobUrl = URL.createObjectURL(blob)
      successCallback(blobUrl)
    })
    .catch(error => {
      errorCallback(error.message)
    })
}

export async function uploadFile(url, fileInfo, uploadCallback) {
  console.log('utils.uploadFile', url, fileInfo)
  const formData = new FormData()
  formData.append('theFile', fileInfo.file)
  formData.append('newFileName', fileInfo.newFileName)
  const xhr = new XMLHttpRequest()
  xhr.onload = ((e) => { uploadCallback(e, fileInfo) })
  xhr.onerror = ((e) => { uploadCallback(e, fileInfo) })
  xhr.upload.onprogress = ((e) => { uploadCallback(e, fileInfo) })
  xhr.open('POST', url)
  const jwt = getLoginItem('jwt')
  xhr.setRequestHeader('Authorization', `Bearer ${jwt}`)
  xhr.send(formData)
}

export function removeFileNamePrefix(fileName, delimiter) {
  if (fileName) {
    const slashPosition = fileName.lastIndexOf(delimiter)
    if (slashPosition > -1) {
      return fileName.substr(slashPosition + 1)
    }
  }
  return fileName
}

export function fileUrl(fileName) {
  const baseName = getBaseName()
  const url = `${baseName}file/${escape(fileName)}`
  return url
}

export async function getToken(successCallback, errorCallback) {
  const tenant = getTenant()
  const url = `${process.env.REACT_APP_SERVER}/token/${tenant}`
  const jwt = getLoginItem('jwt')
  fetch(url, {
    method: 'get',
    mode: 'cors',
    headers: {
      'Authorization': `Bearer ${jwt}`
    }
  })
    .then(response => response.json())
    .then(data => { successCallback(data.jwt) })
    .catch(error => errorCallback(error))
}

export function configValue(key) {
  let configValue = null
  const configObject = getLoginItem('configuration')
  if (configObject) {
    configValue = configObject[key.toUpperCase()]
  }
  return configValue
}

export function getFieldType(fieldTypeId) {
  const fieldTypes = getLoginItem('fieldTypes')
  for (let fieldType of fieldTypes) {
    if (makeInteger(fieldType.id) === makeInteger(fieldTypeId)) {
      return fieldType
    }
  }
  return null
}

export function getAttributeValue(name) {
  let attributeValue = null
  const attributesListObject = getLoginItem('attributes')
  if (attributesListObject) {
    const attributeObject = attributesListObject[name.toUpperCase()]
    if (attributeObject) {
      attributeValue = attributeObject.value
    }
  }
  return attributeValue
}

export function setAttributeValue(name, value) {
  console.log('utils.setAttributeValue: ', { name, value })
  const attributes = getLoginItem('attributes')
  attributes[name.toUpperCase()].value = value
  setLoginItem('attributes', attributes)
}

export function passwordErrors(password) {
  const errors = []
  let passCount = 0
  let tooShort = false
  if (password.length < 8) {
    tooShort = true
    errors.push('The password must be at least 8 characters in length')
  }
  if (!(password !== password.toLowerCase())) {
    errors.push('The password does not contain any upper case letters')
  } else {
    passCount++
  }
  if (!(password !== password.toUpperCase())) {
    errors.push('The password does not contain any lower case letters')
  } else {
    passCount++
  }
  if (!password.match(/[0-9]/g)) {
    errors.push('The password does not contain any numbers')
  } else {
    passCount++
  }
  if (!(/[~`!@#$%^&*+=\-[\]\\';,/{}|\\":<>?()._]/g.test(password))) {
    errors.push('The password does not contain any special characters')
  } else {
    passCount++
  }
  if (tooShort || passCount < 3) {
    return errors
  }
  return null
}

export function getChangeCount(formInputs) {
  let changeCount = 0
  for (let fieldId in formInputs) {
    const fieldInput = formInputs[fieldId]
    if (fieldInput.changed) {
      changeCount++
    }
  }
  return changeCount
}

export function handleGraphQLErrors(error, setGraphQLErrors) {
  console.log(JSON.stringify(error))
  if (error){
    if (CombinedGraphQLErrors.is(error)) {
      const errors = error.errors.map((error) => {
        return error.message
      })
      setGraphQLErrors(errors)
    } else if (error.message) {
      setGraphQLErrors([{message: error.message}])
    }
  }
}

export function enterKeyHandler(submitFunction) {
  return (event) => {
    if (event.key === 'Enter') {
      submitFunction()
    }
  }
}

export function replaceUnicode(text) {
  return text.replace('&#8356;', '\u00a3')
}

export function dateTimeStamp() {
  const options = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false,
    timeZone: 'America/New_York',
  }
  const date = new Date()
  return new Intl.DateTimeFormat('en-US', options).format(date)
}

function isObject(object) {
  return object != null && typeof object === 'object'
}

export function deepEqual(object1, object2) {
  const keys1 = Object.keys(object1)
  const keys2 = Object.keys(object2)

  if (keys1.length !== keys2.length) {
    return false
  }

  for (const key of keys1) {
    const val1 = object1[key]
    const val2 = object2[key]
    const areObjects = isObject(val1) && isObject(val2)
    if ((areObjects && !deepEqual(val1, val2)) || (!areObjects && val1 !== val2)) {
      return false
    }
  }

  return true
}

export function convertTextToDate(text) {
  const temp1 = text.substring(text.indexOf(' ')+1)
  const dateString = temp1.substring(0, temp1.indexOf(','))
  // Split the date part into month, day, and year
  const [month, day, year] = dateString.split('/').map(Number)
  // Create a new Date object
  const lineDate = new Date(year, month - 1, day)
  return lineDate
}

export function getDifferenceInDays(date1, date2) {
  const oneDay = 24 * 60 * 60 * 1000 // milliseconds in a day

  // Convert dates to milliseconds
  const date1ms = date1.getTime()
  const date2ms = date2.getTime()

  // Calculate the absolute difference in milliseconds
  const diffInMs = Math.abs(date1ms - date2ms)

  // Convert back to days and round down
  return Math.round(diffInMs / oneDay)
}
